import { useState, useEffect, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';

export default function SoundwavePage() {
  const images = [
    'https://static.readdy.ai/image/af0cbc08a3b78af074c92730eb798524/70f4102a543529ce045e62e6a791d2fb.jpeg',
    'https://public.readdy.ai/ai/img_res/c39dab49522d9a5042cf35ba54396d45.jpg',
    'https://readdy.ai/api/search-image?query=luxury%20superyacht%20master%20suite%20bedroom%20with%20king%20size%20bed%2C%20elegant%20design%2C%20panoramic%20windows%2C%20sophisticated%20lighting%2C%20premium%20fabrics%20and%20finishes&width=1200&height=800&seq=soundwave3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=luxury%20superyacht%20sundeck%20with%20jacuzzi%2C%20sun%20loungers%2C%20outdoor%20dining%20area%2C%20bar%2C%20stunning%20ocean%20views%2C%20teak%20decking%2C%20elegant%20outdoor%20furniture&width=1200&height=800&seq=soundwave4&orientation=landscape',
    'https://readdy.ai/api/search-image?query=luxury%20superyacht%20beach%20club%20and%20swim%20platform%20with%20water%20toys%2C%20jet%20skis%2C%20tender%2C%20direct%20ocean%20access%2C%20modern%20design%2C%20inviting%20water%20level%20space&width=1200&height=800&seq=soundwave5&orientation=landscape',
    'https://readdy.ai/api/search-image?query=luxury%20superyacht%20formal%20dining%20room%20with%20elegant%20table%20setting%20for%2014%20guests%2C%20crystal%20chandeliers%2C%20sophisticated%20decor%2C%20panoramic%20windows&width=1200&height=800&seq=soundwave6&orientation=landscape'
  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    preferredDates: '',
    destination: '',
    guests: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  const scrollToInquiry = () => {
    document.getElementById('inquiry-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://readdy.ai/api/form/d5k0acv9u36dslcghemg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          yacht: 'SOUNDWAVE',
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          preferredDates: formData.preferredDates,
          destination: formData.destination,
          guests: formData.guests,
          message: formData.message
        }).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          preferredDates: '',
          destination: '',
          guests: '',
          message: ''
        });
        setTimeout(() => {
          setSubmitStatus('idle');
        }, 3000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Image Gallery */}
      <section className="relative h-screen mt-20">
        <div className="absolute inset-0">
          <img
            src={images[currentImage]}
            alt="Soundwave Superyacht"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={prevImage}
          className="absolute left-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-2xl"></i>
        </button>
        <button
          onClick={nextImage}
          className="absolute right-6 top-1/2 -translate-y-1/2 w-14 h-14 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-all z-10 cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-2xl"></i>
        </button>

        {/* Image Counter */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-black/60 text-white px-4 py-2 rounded-full text-sm">
          {currentImage + 1} / {images.length}
        </div>

        {/* Yacht Title Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-12 text-white z-10">
          <div className="max-w-7xl mx-auto">
            <h1 className="text-6xl font-bold mb-4">SOUNDWAVE</h1>
            <div className="flex items-center gap-8 text-lg mb-6">
              <span>Benetti 2015</span>
              <span>•</span>
              <span>63m / 206ft</span>
              <span>•</span>
              <span>14 Guests</span>
              <span>•</span>
              <span>16 Crew</span>
            </div>
            <button
              onClick={scrollToInquiry}
              className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              Request Charter Information
            </button>
          </div>
        </div>
      </section>

      {/* Quick Specs Bar */}
      <section className="bg-gray-50 py-8 border-b">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">$650,000</div>
              <div className="text-sm text-gray-600">Per Week (High Season)</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">$600,000</div>
              <div className="text-sm text-gray-600">Per Week (Low Season)</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">14</div>
              <div className="text-sm text-gray-600">Maximum Guests</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">7</div>
              <div className="text-sm text-gray-600">Luxurious Cabins</div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Left Column - Main Info */}
            <div className="lg:col-span-2 space-y-12">
              {/* Overview */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Overview</h2>
                <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
                  <p>
                    SOUNDWAVE is a magnificent 63-meter Benetti superyacht built in 2015, representing the pinnacle of Italian yacht building excellence. This stunning vessel combines elegant design with exceptional performance, offering an unforgettable charter experience in the world's most exclusive destinations.
                  </p>
                  <p>
                    With accommodation for up to 14 guests in 7 beautifully appointed cabins, SOUNDWAVE provides the perfect setting for families, groups of friends, or corporate events. Her spacious interior volumes and thoughtful layout ensure every guest enjoys privacy, comfort, and luxury throughout their charter.
                  </p>
                  <p>
                    The yacht's exterior spaces are equally impressive, featuring multiple deck areas for dining, sunbathing, and entertainment. From the expansive sundeck with its jacuzzi and bar to the beach club with direct water access, SOUNDWAVE offers endless opportunities to enjoy life on the water.
                  </p>
                </div>
              </div>

              {/* Specifications */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Specifications</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Length</div>
                    <div className="text-xl font-semibold">63 Meters / 206 Feet</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Beam</div>
                    <div className="text-xl font-semibold">10.8 Meters / 35 Feet</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Draft</div>
                    <div className="text-xl font-semibold">3.5 Meters / 11 Feet</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Gross Tonnage</div>
                    <div className="text-xl font-semibold">1181 GT</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Cruising Speed</div>
                    <div className="text-xl font-semibold">14 Knots</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Year Built</div>
                    <div className="text-xl font-semibold">2015</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Builder</div>
                    <div className="text-xl font-semibold">Benetti</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Hull Type</div>
                    <div className="text-xl font-semibold">Motor Yacht</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Interior Designer</div>
                    <div className="text-xl font-semibold">Candy & Candy</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-sm text-gray-600 mb-1">Exterior Designer</div>
                    <div className="text-xl font-semibold">Achille Salvagni</div>
                  </div>
                </div>
              </div>

              {/* Accommodation */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Accommodation</h2>
                <div className="bg-gray-50 p-8 rounded-lg">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-2xl font-bold">14 Guests</div>
                      <div className="text-gray-600">Maximum Capacity</div>
                    </div>
                  </div>
                  <div className="space-y-4 text-gray-700">
                    <p className="leading-relaxed">
                      SOUNDWAVE accommodates up to 14 guests in 7 exquisitely designed cabins, each featuring en-suite facilities and the finest amenities. The master suite is a private sanctuary spanning the full beam of the yacht, with panoramic windows, a king-size bed, walk-in wardrobes, and a luxurious marble bathroom.
                    </p>
                    <p className="leading-relaxed">
                      Additional guest accommodation includes VIP suites and guest cabins, all finished to the highest standards with premium fabrics, sophisticated lighting, and entertainment systems. Every cabin offers a peaceful retreat with stunning ocean views.
                    </p>
                  </div>
                </div>
              </div>

              {/* Toys & Amenities */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Toys & Amenities</h2>
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-ship-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Tenders</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-motorbike-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Jet Skis</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-water-flash-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Water Skis</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-sailboat-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Inflatable Small Misc</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-surfboard-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Wind Surf</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-anchor-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Kayaks</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-fishing-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Fishing Gear</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-swim-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Snorkeling Equipment</div>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg text-center">
                    <i className="ri-mountain-line text-4xl text-teal-600 mb-3"></i>
                    <div className="font-semibold">Inflatable Climbing Wall</div>
                  </div>
                </div>
              </div>

              {/* Charter Destinations */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Charter Destinations</h2>
                <div className="bg-gradient-to-br from-teal-50 to-blue-50 p-8 rounded-lg">
                  <div className="flex items-start gap-4 mb-6">
                    <i className="ri-map-pin-line text-3xl text-teal-600 mt-1"></i>
                    <div>
                      <h3 className="text-2xl font-bold mb-2">Mediterranean</h3>
                      <p className="text-gray-700 leading-relaxed">
                        SOUNDWAVE is primarily available for charter in the stunning Mediterranean, offering access to the French Riviera, Italian coastline, Greek Islands, and beyond. Experience the glamour of Monaco, the beauty of the Amalfi Coast, or the tranquility of secluded Greek islands.
                      </p>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 mt-6">
                    <div className="bg-white p-4 rounded-lg">
                      <div className="font-semibold text-teal-600 mb-1">Summer Season</div>
                      <div className="text-sm text-gray-600">West Mediterranean (May - September)</div>
                    </div>
                    <div className="bg-white p-4 rounded-lg">
                      <div className="font-semibold text-teal-600 mb-1">Winter Season</div>
                      <div className="text-sm text-gray-600">Available on Request</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Crew */}
              <div>
                <h2 className="text-4xl font-bold mb-6">Professional Crew</h2>
                <div className="bg-gray-50 p-8 rounded-lg">
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center">
                      <i className="ri-team-line text-3xl text-white"></i>
                    </div>
                    <div>
                      <div className="text-2xl font-bold">16 Crew Members</div>
                      <div className="text-gray-600">Highly Experienced & Professional</div>
                    </div>
                  </div>
                  <p className="text-gray-700 leading-relaxed">
                    SOUNDWAVE's crew of 16 highly trained professionals is dedicated to providing exceptional service throughout your charter. Led by an experienced captain and including skilled chefs, stewardesses, deckhands, and engineers, the crew ensures every aspect of your journey is seamless and memorable. Their attention to detail, discretion, and warm hospitality create an atmosphere of refined luxury.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column - Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 space-y-6">
                {/* Charter Rates */}
                <div className="bg-gradient-to-br from-teal-500 to-teal-600 text-white p-8 rounded-lg">
                  <h3 className="text-2xl font-bold mb-6">Charter Rates</h3>
                  <div className="space-y-4">
                    <div className="border-b border-white/20 pb-4">
                      <div className="text-sm opacity-90 mb-1">High Season</div>
                      <div className="text-3xl font-bold">$650,000</div>
                      <div className="text-sm opacity-90">per week + expenses</div>
                    </div>
                    <div className="pb-4">
                      <div className="text-sm opacity-90 mb-1">Low Season</div>
                      <div className="text-3xl font-bold">$600,000</div>
                      <div className="text-sm opacity-90">per week + expenses</div>
                    </div>
                  </div>
                  <button
                    onClick={scrollToInquiry}
                    className="w-full bg-white text-teal-600 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-all mt-6 whitespace-nowrap cursor-pointer"
                  >
                    Request Charter Quote
                  </button>
                </div>

                {/* Quick Facts */}
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-4">Quick Facts</h3>
                  <div className="space-y-3 text-sm">
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Builder</span>
                      <span className="font-semibold">Benetti</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Year</span>
                      <span className="font-semibold">2015</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Length</span>
                      <span className="font-semibold">63m / 206ft</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Guests</span>
                      <span className="font-semibold">14</span>
                    </div>
                    <div className="flex justify-between py-2 border-b border-gray-200">
                      <span className="text-gray-600">Cabins</span>
                      <span className="font-semibold">7</span>
                    </div>
                    <div className="flex justify-between py-2">
                      <span className="text-gray-600">Crew</span>
                      <span className="font-semibold">16</span>
                    </div>
                  </div>
                </div>

                {/* Contact Broker */}
                <div className="bg-gray-900 text-white p-6 rounded-lg">
                  <h3 className="text-xl font-bold mb-4">Contact Broker</h3>
                  <p className="text-sm text-gray-300 mb-6">
                    Speak with our charter specialists to discuss availability, itineraries, and special requests.
                  </p>
                  <button
                    onClick={scrollToInquiry}
                    className="w-full bg-teal-500 hover:bg-teal-600 text-white py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Charter Inquiry Form */}
      <section id="inquiry-form" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Request Charter Information</h2>
            <p className="text-xl text-gray-600">
              Complete the form below and our charter specialists will contact you within 24 hours
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-lg">
            {submitStatus === 'success' ? (
              <div className="py-12 text-center">
                <i className="ri-check-line text-5xl text-green-600 mb-4"></i>
                <p className="text-lg">Thank you for your inquiry. We'll be in touch shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} data-readdy-form id="charter-inquiry-form">
                <div className="space-y-6">
                  <div>
                    <label className="block text-xs tracking-wider mb-2">NAME *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">EMAIL *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">PHONE</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">PREFERRED DATES</label>
                    <input
                      type="text"
                      name="preferredDates"
                      placeholder="e.g., July 15-22, 2024"
                      value={formData.preferredDates}
                      onChange={(e) => setFormData({ ...formData, preferredDates: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">DESTINATION</label>
                    <input
                      type="text"
                      name="destination"
                      value={formData.destination}
                      onChange={(e) => setFormData({ ...formData, destination: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">NUMBER OF GUESTS</label>
                    <input
                      type="number"
                      name="guests"
                      min="1"
                      value={formData.guests}
                      onChange={(e) => setFormData({ ...formData, guests: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors cursor-text"
                    />
                  </div>

                  <div>
                    <label className="block text-xs tracking-wider mb-2">MESSAGE</label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      className="w-full px-4 py-3 text-sm border border-gray-300 focus:outline-none focus:border-black transition-colors resize-none cursor-text"
                    ></textarea>
                    <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500 characters</p>
                  </div>

                  {submitStatus === 'error' && (
                    <div className="p-4 bg-red-50 border border-red-200">
                      <p className="text-sm text-red-600">There was an error submitting your inquiry. Please try again.</p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-4 bg-black text-white text-sm tracking-wider hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? 'SUBMITTING...' : 'SUBMIT INQUIRY'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
